<template>
  <div>
    <search
      :title="`${$t('modal.warehouse')}`"
      :items="warehouses"
      idProperty="WarehouseId"
      nameProperty="WarehouseName"
      @triggerClick="triggerClick"
      @remove="remove"
      :searchItems="searchItems"
    />

    <warehouse-select
      :isMultiple="true"
      :trigger="trigger"
      :defaultItems="defaultItems"
      @onSaved="add"
    />
  </div>
</template>

<script>
import search from "./Search";
import warehouseSelect from "@/components/selects/WarehouseSelects";

export default {
  data() {
    return {
      trigger: false,
      warehouses: [],
      defaultItems: undefined,
    };
  },
  props: {
    searchItems: {
      type: Object,
      default: () => ({}),
    },
  },
  watch: {
    searchItems(value) {
      if (JSON.parse(sessionStorage.getItem("isSamePage")) && value.Warehouse) {
        this.warehouses = value.Warehouse;
      }
    },
  },
  components: {
    search,
    warehouseSelect,
  },
  methods: {
    triggerClick() {
      this.defaultItems = [...this.warehouses];
      this.trigger = !this.trigger;
    },
    add(items) {
      this.warehouses = items;
      this.set();
    },
    remove(index) {
      if (!this.warehouses[index]) return;
      this.warehouses.splice(index, 1);
      this.set();
    },
    set() {
      this.$emit("set", this.warehouses);
    },
  },
};
</script>
